/**
 * 4.0商详页-内容组件-计算器
 */
 import { CountUp } from "countup.js";
 import { gaProductDetailDataLayer, getSavings } from "@utils/index.js"
 function throttle_Z(fn, delay) {
  let timer;
  return function () {
    if (!timer) {
      timer = setTimeout(() => {
        fn.apply(this, arguments);
        timer = null;
      }, delay);
    }
  }
}
 export function PdpCalculator() {
   (function () {
     $(function () {
       // 数字动效
       function countUp(idName, result, decimalPlacesVal = 1) {
         let options = {
           decimalPlaces: decimalPlacesVal,
           duration: 1
         };
         if (Shopify.currency.active === 'EUR') {
           options.separator = '.';
           options.decimal = ',';
         };
         let numVal = new CountUp(idName, Number(result), options);
         if (!numVal.error) {
           numVal.start();
         } else {
           console.error(numVal.error);
         }
       }

 
       /**
        * 有效时长功能及交互
        * @param {jQuery} $pdpCalc - 计算器容器元素
        * @param {string} id - 计算器 ID
        * @param {number} capacity - 电池容量
        * @param {number} efficiency - 效率
        */
       function handleHoursCalculation($pdpCalc, id, capacity, efficiency) {
         const $powerInp = $pdpCalc.find(`.power-inp`);
         let maxPower = $powerInp.data('max-power');
         let acConsumption = $powerInp.data('ac_consumption');
 
         $(window).scroll(throttle_Z(function () {
           if (window.Jackery.Utils.isElementInViewport($powerInp[0])) {
             $powerInp.focus();
           } else {
             $powerInp.blur();
           }
         }, 300));
 
         $powerInp.blur(function () {
           $(this).parent().removeClass('active');
         });
 
         const $errorTips = $pdpCalc.find(`.error-tips`);
         const $resultNum = $pdpCalc.find(`.result-num`);
         let $btnTips = $pdpCalc.find(`.btn-tips`);
 
         function handlePowerInp() {
           $btnTips.hide();
 
           let currVal = $powerInp.val();
           if (currVal) {
             if (Number(currVal) > Number(maxPower)) {
               $errorTips.show();
             } else {
               let result = window.getRunningTime(Number(currVal), Number(capacity), Number(efficiency), Number(acConsumption));
               countUp(`${id}-resultNum`, result);
               $errorTips.hide();
 
               // 数据埋码
               gaProductDetailDataLayer({
                 "product_spu_name": $pdpCalc.data("product-title"), //识别页面产品spu标题名称text
                 "module": "Calculator", //固定名称Calculator
                 "position": Number(currVal), // 识别输入的具体瓦数
                 "button_name": "equal", // 按钮固定命名equal
               })
             }
           } else {
             $resultNum.text('00');
             $errorTips.hide();
           }
         }
 
         // 输入框输入触发
         let $btnEnter = $pdpCalc.find(`.btn-enter`);
 
         
         $powerInp.on('input', throttle_Z(function () {
           
           let inpVal = $(this).val();
           let btnOnceShow = $pdpCalc.find('.btn-tips').attr('data-once-show');
           if (inpVal) {
             $btnEnter.attr('disabled', false);
             if (btnOnceShow === 'false') {
               $btnTips.show();
               $btnTips.attr('data-once-show', 'true');
             }
           } else {
             $btnEnter.attr('disabled', true);
             $btnTips.hide();
           }
         }, 300))
 
         // 等号按钮触发
         $btnEnter.click(function () {
           handlePowerInp();
         });
 
         // 回车键触发
         $powerInp.on('keypress', function (event) {
           if (event.which === 13) {
             handlePowerInp();
           }
         });
       }
 
       /**
        * 节省成本功能及交互
       * @param {jQuery} $pdpCalc - 计算器容器元素
       * @param {string} id - 计算器 ID
       * @param {number} capacity - 电池容量
       * @param {number} efficiency - 效率
        */
       function handleCostSavingsCalculation($pdpCalc, id, capacity, efficiency) {
         const $costInp = $pdpCalc.find(`.cost-inp`);
         const $timesInp = $pdpCalc.find(`.times-inp`);
         const $btnEnter = $pdpCalc.find(`.btn-enter`);
         const $costInpBox = $costInp.parent();
         const $timesInpBox = $timesInp.parent();
 
         $(window).scroll(throttle_Z(function () {
           if (window.Jackery.Utils.isElementInViewport($costInp[0])) {
             if ($costInpBox.hasClass('active') || $timesInpBox.hasClass('active')) return;
             $costInp.focus().parent().addClass('active');
           } else {
             $costInp.blur();
           }
         }, 300));
 
         // 监听input的blur事件
         $costInp.blur(function () {
           $costInpBox.removeClass('active');
           const currVal = $(this).val();
           const timesVal = $timesInp.val();
           if (currVal) {
             if (!timesVal) {
               $costInpBox.removeClass('active');
               $timesInpBox.addClass('active');
               $timesInp.focus();
             } else {
               $btnEnter.attr('disabled', false);
             }
           }
         });
 
         $timesInp.blur(function () {
           $(this).parent().removeClass('active');
           const currVal = $(this).val();
           const costVal = $costInp.val();
           if (currVal && costVal) {
             $btnEnter.attr('disabled', false);
           }
         });
         
         console.log("----T")
         $pdpCalc.find('input')
           .on('input', throttle_Z(function () {
           console.log("----put")
             
             validateForm();
           }, 300))
           .on('focus', function () {
             $pdpCalc.find('input').removeClass('active');
             $(this).parent().addClass('active');
           })
 
         function validateForm(type) {
           const costVal = $costInp.val();
           const timesVal = $timesInp.val();
           if (!Number(costVal) || !Number(timesVal)) {
             $btnEnter.attr('disabled', true);
           } else {
             $btnEnter.attr('disabled', false);
 
             if (type == "autoCalculate") {
               const result = getSavings(Number(capacity), Number(efficiency), Number(costVal), Number(timesVal));
               countUp(`${id}-resultNum`, result, 2);
             }
           }
         }
 
         // 计算事件执行监听
         $pdpCalc.find('input').on('keypress', function (event) {
           if (event.which === 13) {
             validateForm('autoCalculate');
           }
         });
         $btnEnter.click(function () {
           validateForm('autoCalculate');
         })
       }
 
       $('.pdp-calculator').each(function () {
         const $pdpCalc = $(this);
         const id = $pdpCalc.data('id');
         const type = $pdpCalc.data('type') || 'ui-hrs';
         let capacity = $pdpCalc.data('capacity');
         let efficiency = $pdpCalc.data('efficiency');
         if (type === 'ui-hrs') {
           handleHoursCalculation($pdpCalc, id, capacity, efficiency);
         } else {
           handleCostSavingsCalculation($pdpCalc, id, capacity, efficiency);
         }
       })
     })
   })();
 }
 